module.exports = "span.progress {\n  width: 25px;\n  float: right;\n  display: block;\n  height: 25px;\n  margin: 5px 0 0 10px;\n  background: transparent; }\n"